import React from "react";
import Button from "../Button";

const CardPriceButtonLink = ({ href, children, ...props }) => (
	<Button.Link
		href={href}
		styleType="primary"
		isBlock
		className="card-price__action-button"
		{...props}
	>
		{children}
	</Button.Link>
);

CardPriceButtonLink.propTypes = {
	...Button.propTypes,
};

export default CardPriceButtonLink;
